import React from 'react';
import { ListItemIcon, ListItemText, MenuItem } from '@mui/material';
import { styled } from '@mui/system';
import HighlightOff from '../icons/highlightOff';

const StyledListItemIcon = styled(ListItemIcon)({
  minWidth: 36,
});

const MenuCancelButton = ({ handleClick = () => {}, disabled = false }) => {
  return (
    <MenuItem
      onClick={() => handleClick(true)}
      disabled={disabled || null}
      aria-disabled={disabled}
      sx={{ minHeight: '48px !important' }}
    >
      <StyledListItemIcon>
        <HighlightOff />
      </StyledListItemIcon>
      <ListItemText primary="Cancel" />
    </MenuItem>
  );
};

export default MenuCancelButton;
